var map = {
	"./default-board.svg": "1d6f",
	"./gamifinnopolis-sport.min.svg": "059a",
	"./gamifinnopolis.min.svg": "f428",
	"./pirates.min.svg": "5b72",
	"./thumbnails/gamifinnopolis-sport.png": "cfd5",
	"./thumbnails/gamifinnopolis.png": "cfa1",
	"./thumbnails/pirates.png": "5f1e"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "0aed";